import { extend } from 'vee-validate';
import validations from '~/vee-validations';

/**
 * Helper function to help us initialize the `vee-validation` rules
 * that we need inside the overtime policies settings.
 */
export function addOvertimePoliciesValidationRules() {
  // Add VeeValidate custom rules
  extend('collectionsEmpty', validations.collectionsEmpty);
}
